;(function($){

  $(window).ready(init);

  function init() {
    $('.Slider').flexslider();
  }

})(jQuery);
